import { atom } from 'recoil';
import { TScrollSlots } from '../../../game-server/src/modules/enchantment/enchantment.interface';

export const scrollcraftingFilterAtom = atom({
	key: 'scrollcraftingFilterAtom',
	default: 'gloves' as TScrollSlots | null,
});
